const SEVERITY_CONFIG = {
  critical: { color: '#f5222d', size: 18 },
  high: { color: '#fa541c', size: 14 },
  medium: { color: '#faad14', size: 10 },
  low: { color: '#1890ff', size: 7 },
  info: { color: '#bfbfbf', size: 5 }
};

export const alertTimelineChart = (data = []) => {
  const severities = ['critical', 'high', 'medium', 'low', 'info'];

  const series = severities.map(sev => {
    const cfg = SEVERITY_CONFIG[sev];
    const filtered = data.filter(d => d.severity === sev);
    return {
      name: sev.charAt(0).toUpperCase() + sev.slice(1),
      type: 'scatter',
      data: filtered.map(d => [d.timestamp, sev, d.alertName]),
      symbolSize: cfg.size,
      itemStyle: { color: cfg.color, opacity: 0.8 }
    };
  });

  return {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        const [ts, sev, name] = params.data;
        return `<strong>${name || 'Alert'}</strong><br/>Severity: ${sev}<br/>${ts}`;
      }
    },
    legend: {
      data: severities.map(s => s.charAt(0).toUpperCase() + s.slice(1)),
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [...new Set(data.map(d => d.timestamp))].sort(),
      axisLabel: { fontSize: 10 }
    },
    yAxis: {
      type: 'category',
      data: severities.map(s => s.charAt(0).toUpperCase() + s.slice(1)),
      axisLabel: { fontSize: 10 }
    },
    series
  };
};
